"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateWebpackPRODServer = void 0;
var helpers_1 = require("../../../helpers");
var mfeSettings_1 = require("../../mfeSettings");
var webpack_common_1 = require("./webpack.common");
function generateWebpackPRODServer(options, deps) {
    var ENV_CONFIG = options.ENV_CONFIG, sharedMappings = options.sharedMappings;
    var ModuleFederationPlugin = deps.webpack.container.ModuleFederationPlugin, merge = deps.webpackMerge.merge, mf = deps.mf, TerserPlugin = deps.TerserPlugin;
    var common = (0, webpack_common_1.generateAngularCommonConfig)(options, deps);
    var publicBasePath = !!ENV_CONFIG.ENV_NAME.match("local")
        ? ENV_CONFIG.getRemoteEndpointBy(common.type)
        : "/" + mfeSettings_1.MFE_GENERAL_SETTINGS[common.type].basePath;
    var serverConfig = helpers_1.ModuleFederationHelper.buildRemoteModuleFederationConfigs(common.__mfeName__, common.sharedModuleFederationDeps(mf.share, sharedMappings), ENV_CONFIG).serverConfig;
    var prodServerConfig = merge(common.config, {
        mode: "production",
        target: "async-node",
        output: {
            uniqueName: common.__mfeName__ + "AngularProdServer",
            path: common.distPath + common.remotePath + "server",
            publicPath: publicBasePath + common.remotePath + "server/",
            clean: true,
            asyncChunks: false,
        },
        optimization: {
            runtimeChunk: false,
            minimize: true,
            minimizer: [
                new TerserPlugin({
                    exclude: "polyfills.ts",
                    terserOptions: {
                        ecma: undefined,
                        parse: {},
                        compress: {},
                        mangle: true,
                        module: false,
                        // Deprecated
                        output: null,
                        format: null,
                        toplevel: false,
                        nameCache: null,
                        ie8: false,
                        keep_classnames: undefined,
                        keep_fnames: /^(HTML|SVG)/,
                        safari10: false,
                    },
                }),
            ],
            splitChunks: {
                chunks: "async",
                minSize: 20000,
                minRemainingSize: 0,
                minChunks: 1,
                maxAsyncRequests: 30,
                maxInitialRequests: 30,
                enforceSizeThreshold: 50000,
                cacheGroups: {
                    defaultVendors: {
                        test: /[\\/]node_modules[\\/]/,
                        priority: -10,
                        reuseExistingChunk: true,
                    },
                    default: {
                        minChunks: 2,
                        priority: -20,
                        reuseExistingChunk: true,
                    },
                },
            },
        },
        resolve: {
            alias: __assign({}, sharedMappings.getAliases()),
        },
        plugins: [
            new ModuleFederationPlugin(serverConfig),
            sharedMappings.getPlugin(),
        ],
    });
    return prodServerConfig;
}
exports.generateWebpackPRODServer = generateWebpackPRODServer;
